/**
 * Filter list of items by typing in the search field
 */

const filterList = () => {

    const classBound = 'has-bound-filter-search';
    const selector = `.widget-filter:not(${classBound})`;
    let filterListWidget = document.querySelectorAll(selector);

    //for (let element of filterListWidget) {
    for (let i = 0; i < filterListWidget.length; i++) {
        let element = filterListWidget[i];

        if (element.classList.contains(classBound)) {
            continue;
        }

        let filterInput = element.querySelector('.widget-filter-search'),
                filterList = element.querySelector('.widget-filter-list'),
                filterItems = filterList.querySelectorAll('.widget-filter-item');

        if (!filterInput) {
            continue;
        }

        filterInput.addEventListener('keyup', () => {

            let filterValue = filterInput.value.toLowerCase();
            for (let i = 0; i < filterItems.length; i++) {

                let filterText = filterItems[i].querySelector('.widget-filter-item-text').innerHTML;
                if (filterText.toLowerCase().indexOf(filterValue) > -1) {
                    filterItems[i].classList.remove('d-none');
                } else {
                    filterItems[i].classList.add('d-none');
                }
            }

        });

        element.classList.add(classBound);
    }
};

export default filterList;

filterList();
